import React from 'react';
import './Features.css';
import { FaGlobe, FaUniversity, FaMoneyBillWave } from 'react-icons/fa';  // Icon imports from react-icons

const Features = () => {
  return (
    <section id='features' className="features-container">
      <h2 className="section-title">Why Study Abroad?</h2>
      <div className="features">
        <div className="feature">
          <FaGlobe className="feature-icon" />
          <h3>Global Exposure</h3>
          <p>Experience new cultures and broaden your horizons.</p>
        </div>
        <div className="feature">
          <FaUniversity className="feature-icon" />
          <h3>Quality Education</h3>
          <p>Study in top universities with world-class education systems.</p>
        </div>
        <div className="feature">
          <FaMoneyBillWave className="feature-icon" />
          <h3>Scholarships & Funding</h3>
          <p>Get access to scholarships and financial aid programs.</p>
        </div>
      </div>
    </section>
  );
}

export default Features;
